/** @file The playhead's whole frame while stopped, held through playback (no re-render on ticks). */
import { useRef } from 'react';
import { useStore } from 'zustand';
import { playheadStore } from '../../stores/playheadStore';

/** Re-read only while stopped (W3-31); playback keeps the last stopped frame, or the frame at mount if it never stopped. */
export function useStoppedFrame(): number {
  const stopped = useStore(playheadStore, (s) => (s.playing ? null : Math.round(s.frame)));
  const last = useRef<number | null>(null);
  if (stopped !== null) last.current = stopped;
  else last.current ??= Math.round(playheadStore.getState().frame);
  return last.current;
}
